import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DownloadRenameDialogData {
  suggestedFileName: string;
  fileExtension?: string;
}

@Component({
  selector: 'app-download-rename-dialog',
  templateUrl: './download-rename-dialog.component.html',
  styleUrl: './download-rename-dialog.component.scss',
  standalone: false,
})
export class DownloadRenameDialogComponent {
  fileNameControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(255)],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DownloadRenameDialogData,
    private dialogRef: MatDialogRef<DownloadRenameDialogComponent, string | undefined>
  ) {
    this.fileNameControl.setValue(data.suggestedFileName || 'download');
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }

  confirm(): void {
    if (this.fileNameControl.invalid) {
      this.fileNameControl.markAsTouched();
      return;
    }

    const value = (this.fileNameControl.value || '').trim();
    if (!value) {
      return;
    }

    this.dialogRef.close(value);
  }
}
